import { Box, Grid, IconButton, Tab, Tabs, Typography, alpha, styled, useTheme } from "@mui/material";

import BarChartIcon from "@mui/icons-material/BarChart";
import ChartProofWork from "./ChartProofWork";
import DailyProfit from "./DailyProfit";
import { INVESTMENT_CHART_TYPES } from "./constants";
import InvestmentAmount from "./InvestmentAmount";
import InvestmentBarChart from "./InvstmentBarChart";
import InvestmentLineChart from "./InvestmentLineChart";
import { LoadingButton } from "@mui/lab";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { checkInvestmentRulesConfirmation } from "store/slices/investment/investmentSlice";
import { isRTL } from "utils/helpers/isRTL";
import useDispatch from "hooks/useDispatch";
import { useState } from "react";
import { Down } from "assets/Icon";
import { actionButtonBg } from "utils/helpers/actionButtonBg";

function BoxProofWork({ investmentDetail }) {
  const dispatch = useDispatch();
  const theme = useTheme();

  const [showMore, setShowMore] = useState(false);
  const [showChart, setShowChart] = useState(false);
  const [chartType, setChartType] = useState(INVESTMENT_CHART_TYPES.line.key);

  const handleClickShowMore = async (val) => {
    await dispatch(checkInvestmentRulesConfirmation());
    setShowMore(!showMore);
    setShowChart(false)
  };

  const handleChangeTab = (_, tab) => {
    setChartType(tab);
  };

  const toggleShowChart = () => {
    setShowChart((v) => !v);
  };

  return (
    <InvestmentCard>
      <Grid container>
        <Grid item xs={8}>
          <Typography
            textAlign={
              isRTL(investmentDetail?.objPortfolio?.name) ? "right" : "left"
            }
            dir={isRTL(investmentDetail?.objPortfolio?.name) ? "rtl" : "ltr"}
            variant="h5"
            pb={3}
            color="text.main"
          >
            {investmentDetail?.objPortfolio?.name}
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <TabsStyle onChange={handleChangeTab} value={chartType}>
            <Tab
              label={<ShowChartIcon />}
              value={INVESTMENT_CHART_TYPES.line.key}
            />

            <Tab
              label={<BarChartIcon />}
              value={INVESTMENT_CHART_TYPES.bar.key}
            />
          </TabsStyle>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12}>
          {chartType === INVESTMENT_CHART_TYPES.line.key && (
            <InvestmentLineChart investmentDetail={investmentDetail} />
          )}

          {chartType === INVESTMENT_CHART_TYPES.bar.key && (
            <InvestmentBarChart investmentDetail={investmentDetail} />
          )}
        </Grid>
      </Grid>

      <Grid container spacing={1} justifyContent={'end'}>
        <Grid item xs={12}>
          <Box display={"flex"} alignItems={'center'} onClick={toggleShowChart}>
            <Typography variant="subtitle1" color="text.main">
              Fund Assets:
            </Typography>

            <DownButton rotate={showChart}>
              <Down color={theme.palette.text.main} />
            </DownButton>

          </Box>

          <DailyProfit
            lisProfitOrLoss={investmentDetail?.objPortfolio?.lisProfitOrLoss}
          />
        </Grid>

        {showChart && (
          <Grid item xs={12} md={10} lg={8} xl={6} textAlign={'start'}>
            <ChartProofWork coins={investmentDetail?.objPortfolio?.lisCoin} />
          </Grid>
        )}
        {showMore && (
          <InvestmentAmount
            handleClickShowMore={handleClickShowMore}
            investmentDetail={investmentDetail}
          />
        )}

        {!showMore && (
          <Grid item xs={12}>
            <LoadingButton
              disabled={showMore && !investmentDetail}
              color={actionButtonBg(theme)}
              fullWidth
              variant="contained"
              onClick={handleClickShowMore}
            >
              Create
            </LoadingButton>
          </Grid>
        )}
      </Grid>
    </InvestmentCard>
  );
}

const InvestmentCard = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  borderRadius: "20px",
  background: theme.palette.background.primaryGradient,
  padding: theme.spacing(2),
  border: "1px solid transparent",
  transition: "all 0.1s",

  "&:hover": {
    border: `1px solid ${alpha(
      theme.palette.secondary.main,
      0.3
    )}`,
    background: `linear-gradient(0deg, ${alpha(
      theme.palette.secondary.main,
      0.1
    )} 0%, rgba(0,38,78,0) 100%)`,
  },
}));

const TabsStyle = styled(Tabs)(() => ({
  ".MuiTabs-flexContainer": {
    justifyContent: "flex-end",
  },
}));

const DownButton = styled(IconButton)(({ rotate }) => ({
  'svg': {
    transition: "0.5s",
    transform: `rotate(${rotate ? '-180deg' : '0deg'})`
  }
}));

export default BoxProofWork;
